<template>
    <popup :opened="dataToShow" @close="close">
        <!-- BEGIN Display Content File -->
        <img
            v-if="file && constants.FILE_TYPES.img.includes((file.type || '').toLowerCase())"
            :src="'/depotdocs/'+file.full_path"
            class="object-contain w-full h-screen rounded-md" alt=""
        />
        <embed
            v-else-if="file && constants.FILE_TYPES.pdf.includes((file.type || '').toLowerCase())"
            :src="'/depotdocs/'+file.full_path"
            class="w-full h-screen rounded-md"
        />
        <!-- END Display Content File -->
    </popup>
</template>

<script>
import Icon from './../../../components/Icon';
import ClickOutside from 'vue-click-outside';
import Constants from './../../../constants';
import Popup from './../../../components/Popup.vue';

export default {
  components:{
    Icon,
    Popup,
  },

  props:{
    file:{
      type: Object,
      required:true,
    },
    dataToShow: Boolean,
  },

  data(){
    return {
      constants: Constants,

    };
  },

  mounted(){

  },

  methods:{
    close(){
      this.$emit('close');
    },
  },

  directives: {
    ClickOutside
  }
};
</script>
